// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mVdG","colBig":"styles_colBig__18DtK","colSmall":"styles_colSmall__1FZP4","shopifyNameWrapper":"styles_shopifyNameWrapper__2M8KC"};